module.exports = __webpack_public_path__ + "media/images/ln/num_2-f35395bd3380e0be4cb5689ce7ffc351.png";